import {removeContracts} from "../../../../../api/asset/AssetContractService";
import {handleActiveError, handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import React, {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import Search from "../../../../../components/search/Search";
import {SearchComboBox} from "../../../../../components/select/SearchComboBox";
import {ASSET_CONTRACT_LIST_HEADER} from "../../../../../components/table/header/Headers";
import SearchSection from "../../../../../components/search/SearchSection";
import {searchListener} from "../../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../../components/selector/Selector";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import {CacheType} from "../../../../../constant/CodeSpecNum";
import {useCacheRefresh} from "../../../../../hooks/useCacheRefresh";
import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";

export const type = [
    {id: "등록일", name: "등록일"},
    {id: "계약일", name: "계약일"},
    {id: "계약기간", name: "계약기간"}
];

export const contractType = [
    {id: "없음", name: "없음"},
    {id: "통합유지보수", name: "통합유지보수"},
    {id: "개별유지보수", name: "개별유지보수"},
    {id: "ACS(인력지원)", name: "ACS(인력지원)"},
    {id: "인프라(콜센터)", name: "인프라(콜센터)"},
];

export const contractClassification = [
    {id: "하자보수(무상)", name: "하자보수(무상)"},
    {id: "유지관리(유상)", name: "유지관리(유상)"}
];

export const contractEndOfDate = [
    {id: "1", name: "계약만료 1개월 전"},
    {id: "2", name: "계약만료 3개월 전"},
    {id: "3", name: "계약만료"}
];

function AssetContractListType({checked, data, date, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const refreshCache = useCacheRefresh();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: ASSET_CONTRACT_LIST_HEADER, exclude: []});

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, ASSET_CONTRACT_LIST_HEADER, setHeader, [], () => {}, () => {}, 'contract');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "계약 상세"),
            url: `/asset/contract/${id}`,
        });
    };

    const deleteContract = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 계약을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeContracts({ids}).then(response => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
                refreshCache(CacheType.contract);
            } else if (response.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const contractJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search entity={"contract"} refresh={refresh} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size detail date={searchDate} searchBar={{placeHolder: '계약명, 계약번호, 계약종류, 구분'}}>
                <SearchSection>
                    <SearchComboBox title={"날짜조건"} code={type} target={"dateType"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "dateType")}
                    />
                    <SearchComboBox title={"계약구분"} code={contractType} target={"contractType"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "contractType")}
                    />
                    <SearchComboBox title={"계약종류"} code={contractClassification} target={"contractClassification"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "contractClassification")}
                    />
                    <SearchComboBox title={"계약 기간만료"} code={contractEndOfDate} target={"type"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "type")}
                    />
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'company', extractObject(saveConditions), value)}
                                 data={saveConditions.company}
                                 entity={"company"} title={"업체"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                    </Selector>
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={contractJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {contract: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'contract')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="AssetContract" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteContract}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        disabled={ctx.disabled}
                                        onClick={() => void ctx.transferSelected()}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/asset/contract/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default AssetContractListType;
